<template>
  <div>
    <dialog-edit2 :value="value" @input="$emit('input')" :makeFocus="false">
      <template v-slot:title> Выбор основания для оплаты </template>
      <v-card-text style="height: 70vh; overflow: auto" class="pa-0">
        <a-table-f-api
          v-if="type == 'get'"
          ref="table"
          :api="url"
          :model="model"
          :useQuery="true"
          :defaults="{
            sort: { key: 'id', order: 'DESC' },
            filters: filter,
            paramName: 'documentParent',
          }"
          @click="clickRow"
        />
        <a-table-f-api-post
          v-if="type == 'apiPost'"
          ref="table"
          :apiPost="{ api: url, params: paramsApi }"
          :limit="50"
          :model="model"
          :useQuery="false"
          :defaults="{
            sort: { key: 'id', order: 'DESC' },
            filters: filter,
            paramName: 'documentParent',
          }"
          @click="clickRow"
        />
      </v-card-text>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit2>
  </div>
</template>

<script>
import { getAccess, genModel } from "@/components/mixings";

export default {
  components: {},
  mixins: [getAccess, genModel],
  props: {
    value: Boolean,
    object_id: Number,
    config: { type: Object, default: () => {} },
  },
  data() {
    return {
      type: null,
      url: null,
      paramsApi: null,
    };
  },
  computed: {
    model() {
      const m = this.config.document.model;
      let model;
      let fields = this.config.document.docFields.split(",") || [];
      if (typeof m == "string") {
        model = JSON.parse(JSON.stringify(this.$store.getters["config/get"].models[m]));
        model = this.getModelList(model, this.config.document?.modelListName || "list");
        model = model.filter(el => {
          return fields.includes(el.name);
        });
        model.forEach(m => {
          m.hidden = false;
        });
      }
      if (typeof m == "object" && !Array.isArray(m)) {
        model = JSON.parse(JSON.stringify(m));
        model = this.getModelList(model, "list");
      }
      if (typeof m == "object" && Array.isArray(m)) {
        model = JSON.parse(JSON.stringify(m));
      }

      return model;
    },
    url1() {
      return this.config.document.api;
    },
    filter() {
      return this.config.document?.filter || {};
    },
  },
  created() {
    this.init(this.config);
  },
  watch: {
    value() {
      if (this.value) {
      }
    },
  },
  methods: {
    init(opts) {
      const type = this.getType();
      if (type == "apiPost") {
        this.url = opts.document.apiPost.api;
        this.paramsApi = opts.document.apiPost.params || {};
      } else {
        this.url = opts.document.api;
      }
      this.type = type;
    },
    getType() {
      if (this.config.document?.apiPost) return "apiPost";
      if (typeof this.config.document.api === "string") return "get";

      return "";
    },
    clickRow(d) {
      this.$emit("select", d.row);
      this.$emit("input");
    },
  },
};
</script>
